import logo from "@attached_assets/Logo Container-original.svg";

interface NavBarSectionProps {
  onCheckoutClick: (e: React.MouseEvent) => Promise<void>;
  isLoading: boolean;
}

export const NavBarSection = ({ onCheckoutClick, isLoading }: NavBarSectionProps) => {
  const handleCheckoutClick = onCheckoutClick;

  return (
    <nav className="sticky top-0 z-50 w-full bg-white border-b border-gray-200 px-4 py-3 sm:py-4">
      <div className="max-w-[1080px] mx-auto flex items-center justify-between">
        <div className="flex items-center">
          <img src={logo} alt="Obeliz.co" className="h-6 sm:h-8" />
        </div>
        <div className="flex items-center space-x-4">
          <button
            onClick={() => window.location.href = '/login'}
            className="text-gray-700 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium"
          >
            Iniciar Sesión
          </button>
          <button
            onClick={handleCheckoutClick}
            disabled={isLoading}
            className="bg-red-600 text-white px-6 py-2 rounded-md hover:bg-red-700 transition-colors"
          >
            {isLoading ? 'Procesando...' : 'Comprar Ahora'}
          </button>
        </div>
      </div>
    </nav>
  );
};
